import React from 'react';
import { UserPicStyles } from './styles.module';


interface IUserPicProps {
  contactData       : any;
  className         : string;
  width            ?: number; // width
  height           ?: number; // height
}

type Props =  IUserPicProps;



export class UserPic extends React.Component<Props> {

  state : any = {}

  getFIO(contact : any) {
    let firstletter = contact.original?.first_name || '-';
    let lastletter = contact.original?.last_name || '-';

    firstletter = firstletter[0]?.toUpperCase();
    lastletter = lastletter[0]?.toUpperCase();

    return {
      firstletter,
      lastletter
    };
  }

  render() {
    const avatarUrl = this.props.contactData.avatar;
    let { firstletter, lastletter } = this.getFIO(this.props.contactData);
    
    return (
        <UserPicStyles className={this.props.className || ''}>

            <div className='pic__meta'>
                <div 
                    className='pic__avatar typo typo-text-14'
                    style={{ width : this.props.width, minWidth : this.props.width, height : this.props.height }}
                >
                  {
                    avatarUrl
                      ? <img src={avatarUrl} width={this.props.width || '40'} height={this.props.height || '40'} />
                      : <span className='pic__avatar-text'>{`${firstletter}${lastletter}`}</span>
                  }
                </div>
            </div>

        </UserPicStyles>
    );
  }
}
